const generateMjml = (sections) => `
  <mjml>
  <mj-head>
    <mj-title></mj-title>
    <mj-font name="Lato" href="https://fonts.googleapis.com/css?display=swap&family=Lato:400,400i,700,700i&subset=cyrillic,greek,latin-ext,vietnamese"></mj-font>
    <mj-font name="Montserrat" href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900"></mj-font>
    <mj-attributes>
      <mj-text font-weight="400" font-size="20px" color="#000000" line-height="24px" font-family="Montserrat" />
      <mj-all font-family="Montserrat" />
    </mj-attributes>
    <mj-style>
      .body {
        width: 800px;
      }
      .zeroMargin td {
        padding: 5px 0 !important;
      }
      .header-wrap {
        display: flex;
        padding: 33px 73px;
        background-color: #293241;
        border-radius: 0px 0px 12px 12px;
        box-shadow: 0px 4px 8px 0px rgba(95, 138, 164, 0.20);
      }
      .header-logo-wrap {
        display: inline-block;
        text-align: center;
      }
      .header-logo-img {
        width: 83px;
        height: 33px;
      }
      .header-link-wrap {
        width: 510px;
        display: inline-block;
        text-align: right;
        margin-top: 5px;
        margin-left: 60px;
        vertical-align: center;
      }
      .header-link {
        color: #eec586 !important;
        font-size: 17px;
        line-height: normal;
        text-decoration: none;
      }
      .header-divider {
        color: #5f8aa4;
        font-size: 22px;
        line-height: 1;
        font-weight: 400;
        text-align: center;
        padding: 0 5px
      }
      .concierge-title {
        padding: 20px 0 16px;
        text-align: center;
        font-size: 14px;
        line-height: normal;
        color: #5e5d5d;
      }
      .concierge-description {
        padding: 0 0 16px;
        text-align: center;
        font-size: 14px;
        line-height: normal;
        color: #293241;
      }
      .concierge-container {
        width: 342px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        gap: 32px;
        margin-bottom: 20px;
      }
      .concierge-wrap-for-item {
        display: inline-block;
      }
      .concierge-icon {
        width: 60px;
        height: 60px;
        margin: 0 auto;
      }
      .concierge-name {
        width: 114px;
        margin-top: 16px;
        font-family: 'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif;
        font-size: 14px;
        font-weight: 400;
        color: #5F8AA4;
        vertical-align: middle;
        text-align: center;
      }
      .pre-footer-content {
        padding: 30px 0;
      }
      .footer-content-block {
        padding: 15px;
        text-align: center;
        background-color: #293241;
        border-radius: 12px;
      }
      .footer-content-block-text {
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        font-weight: 400;
        line-height: normal;
        text-transform: uppercase;
      }
      .footer-button {
        margin: 16px 0;
        padding: 7px 40px;
        text-decoration: none;
        border-radius: 12px 3px;
        border: 1px solid #EAF8FF;
        box-shadow: 4px 4px 8px 0 rgba(95, 138, 164, 0.20);
        display: inline-block;
        color: #d7e8f0 !important;
        background-color: transparent;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        line-height: normal;
      }
      .social-icon-wrap {
        width: 58px;
        height: 32px;
        padding: 0;
        display: inline-block;
        text-align: center;
      }
      .social-icon {
        width: 32px;
        height: 32px;
      }
      .footer-first-bottom-block {
        padding: 20px 0 16px;
      }
      .footer-page-link {
        color: #5f8aa4 !important;
        text-decoration: none;
        font-size: 16px;
        line-height: normal;
        font-weight: 400;
        letter-spacing: 0;
        text-align: center;
      }
      .footer-divider {
        color: #5f8aa4;
        text-decoration: none;
        font-size: 22px;
        line-height: 1;
        font-weight: 400;
        padding: 0 16px;
        text-align: center;
      }
      .footer-copyright-text {
        padding: 0;
        font-size: 16px;
        font-weight: 400;
        color: #7f7f7f !important;
        text-align: center;
        text-decoration: none;
        line-height: 2
      }
      .footer-contact-link {
        display: inline-block;
        width: 100%;
        color: #5f8aa4 !important;
        text-decoration: underline;
      }
      .icon-content-first {
        padding-right: 10px;
      }
      .icon-content {
        padding: 0 10px;
      }
      .icon-content-last {
        padding-left: 10px;
      }
    </mj-style>
    <mj-breakpoint width="800px" />
    <mj-style>
      @media (max-width: 800px) {
        .body {
          width: 412px;
        }
        .header-wrap {
          display: block;
          padding: 0px;
          width: 412px;
          background-color: transparent;
          border-radius: 0px;
          box-shadow: none;
        }
        .header-logo-wrap {
          display: block !important;
          width: 412px;
          height: 56px;
          background: #293241;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .header-logo-img {
          width: 53px;
          height: 21px;
          padding-top: 17px;
        }
        .header-link-wrap {
          display: block !important;
          width: 412px;
          height: 34px;
          margin-top: 0 !important;
          margin-left: 0px;
          color: #FFFFFF;
          background-color: #5F8AA4;
          padding-top: 13px;
          text-align: center;
        }
        .header-link {
          color: #ffffff !important;
          font-size: 14px;
        }
        .header-divider {
          color: #293241;
          font-size: 16px;
          line-height: 1;
          font-weight: 400;
          text-align: center;
          padding: 0 5px
        }
        .concierge-title,
        .concierge-description {
          font-size: 16px;
        }
        .concierge-container {
          width: 100%;
          margin: 0;
          gap: 16px;
        }
        .pre-footer-content {
          padding: 0;
        }
        .footer-content-block {
          width: 372px;
          padding: 20px;
          border-radius: 8px;
        }
        .footer-content-block-text {
          text-align: center;
          font-size: 14px;
          color: #ffffff;
          font-weight: 400;
          line-height: normal;
          text-transform: uppercase;
        }
        .footer-button {
          margin: 16px 0;
          padding: 13px 6px;
        }
        .social-icon-wrap {
          width: 52px;
        }
        .footer-first-bottom-block {
          width: 412px;
          padding-top: 10px;
        }
        .footer-page-link {
          font-size: 14px;
        }
        .footer-divider {
          font-size: 18px;
          padding: 0 5px;
        }
        .footer-copyright-text {
          width: 412px;
          font-size: 14px;
          line-height: 2;
        }
        .footer-contact-link {
          width: 286px;
          padding: 0 63px;
          line-height: 1;
          margin-bottom: 8px;
        }
        .icon-content-first {
          padding-right: 0;
          width: 100%;
          padding-bottom: 20px;
        }
        .icon-content {
          padding: 0;
          width: 100%;
          padding-bottom: 20px;
        }
        .icon-content-last {
          padding-left: 0;
          width: 100%;
        }
      }
    </mj-style>
  </mj-head>
    <mj-body width="800px" css-class="body" >
      ${sections.map(({ style, content, isBigSection }, index, arr) => (!isBigSection
    ? `<mj-wrapper padding="${index === 0 ? '30px' : '0'} 0 ${index === arr.length - 1 ? '30px' : '0'} 0" background-color="#ffffff">
        <mj-section ${Object.entries(style).map(([key, value]) => `${key}="${value}" `).join('')}>
          ${content}
        </mj-section>
      </mj-wrapper>`
    : content)).join('')}
    </mj-body>
  </mjml>
`;

const generateColumns = (columns) => columns.map(({ style: { height, ...restStyle }, content }) => (`
  <mj-column ${Object.entries(restStyle).map(([key, value]) => `${key}="${value}" `).join('')}>
    ${content}
  </mj-column>
`)).join('');

const generateHeading = (text, style) => `
  <mj-text>
    <h2 style="${Object.entries(style).map(([key, value]) => (value ? `${key}: ${value}; ` : '')).join('')}">${text}</h2>
  </mj-text>
`;

const generateText = (text, style) => `
  <mj-text padding="0">
    <div style="${Object.entries(style).map(([key, value]) => (value ? `${key}: ${value}; ` : '')).join('')}">
     ${text}
    </div>
  </mj-text>
`;

const generateSpace = (style) => {
  const { content, ...rest } = style;
  return `<mj-spacer ${Object.entries(rest).map(([key, value]) => `${key}="${value}" `).join('')} />`;
};

const generateSeparator = (style) => {
  const { content, ...rest } = style;
  return `<mj-divider ${Object.entries(rest).map(([key, value]) => `${key}="${value}" `).join('')} />`;
};

const generateImage = ({
  src,
  style,
  isImageWithLink,
  imageLink,
}) => (isImageWithLink
  ? `
    <mj-text align="center">
      <a style="
          width: fit-content;
          height: fit-content;
          border-radius: 20px 3px;
          box-shadow: 4px 4px 8px 0 rgba(95, 138, 164, 0.20);
        " href="${imageLink} " target="_blank">
        <img style="${Object.entries(style).map(([key, value]) => `${key}: ${value}; `).join('')}" src="${src}" />
      </a>
    </mj-text>
  ` : `
    <mj-text align="center">
      <img style="${Object.entries(style).map(([key, value]) => `${key}: ${value}; `).join('')}" src="${src}" />
    </mj-text>

  `);

const generateButton = (
  style,
  href,
  text,
  links,
) => {
  const isConstantLink = links.some((item) => item.value === (href || ''));
  return `
    <mj-button href="${isConstantLink ? `{{${href || ''}}}` : href || ''}" ${Object.entries(style).map(([key, value]) => (value ? `${key}="${value}" ` : '')).join('')}>
      ${text}
    </mj-button>
  `;
};

const generateSocialLinks = () => `
  <mj-social border-radius="50%" icon-size="42px">
    <mj-social-element href="https://www.facebook.com/ForeverStudiosFL" name="facebook-noshare" />
    <mj-social-element href="https://www.instagram.com/forever_studios/" name="instagram" />
    <mj-social-element href="https://www.youtube.com/channel/UCgyUMV4HWMx-XasFPTc7cyQ" name="youtube" />
  </mj-social>
`;

const generateInvoice = () => '<fs-import path="./invoice.html"></fs-import>';

const generateFrameBlock = () => `
  <mj-wrapper padding="0" background-color="#ffffff">
    <mj-section padding="0">
      <mj-column padding="0">
        <mj-text align="center" padding="0">
          {{#each frames}}
            <div style="padding: 10px; width: 260px; display: inline-block;">
              <div style="padding: 5px 5px 15px; width: 240px; border-radius: 0; text-align: center; border: 1px solid #f2f2f2; background-color: #ffffff;">
                <img style="width: 230px; padding-bottom: 20px; border-radius: 0; display: block; text-align: center;" src="{{this.imageUri}}" />
                <div style="padding: 0 5px 10px 5px; text-align: center; font-size: 16px; font-weight: 700; line-height: 1;">{{this.displayName}}</div>
                <div style="padding: 0 5px 10px 5px; text-align: center; font-size: 11px; line-height: 1;">{{this.description}}</div>
                <div style="padding: 0 5px 10px 5px; text-align: center;">
                  <span style="font-size: 12px; padding: 0 2px; color: #5A5A5C; line-height: 1;">from</span>
                  {{#if (ne this.price this.customPrice)}}
                    <span style="font-size: 12px; padding: 0; color: #5A5A5C; text-decoration: line-through #ec6859; line-height: 1;">${'$'}{{this.price}}</span>
                    <span style="font-size: 12px; padding: 0; color: #ec6859; line-height: 1;">${'$'}{{this.customPrice}}</span>
                  {{else}}
                    <span style="font-size: 12px; padding: 0 5px; line-height: 1;">${'$'}{{this.price}}</span>
                  {{/if}}
                </div>
                <a style="font-size: 12px; font-weight: 700; padding: 6px 12px; border-radius: 0; background-color: #2e4a5e; color: #ffffff; line-height: 1; text-decoration: none" href="this.buttonLink" target="_blank">Create now</a>
              </div>
            </div>
          {{/each}}
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-wrapper>
`;

// const generateProofBlock = () => {
//   return `
//     <mj-section>
//       {{#each images}}
//         <mj-column padding="0">
//           <mj-text align="center" padding="0">
//             <a href="{{this.viewProofLink}}" target="_blank">
//               <img src="{{this.imageUri}}" style="width: 180px;"></img>
//             </a>
//           </mj-text>
//         </mj-column>
//       {{/each}}
//     </mj-section>
//   `;
// };

// const generateProofBlock = () => {
//   return `
//     <mj-section>
//       {{#each images}}
//         <mj-column padding="0">
//           <mj-image src="{{this.imageUri}}" href="{{this.viewProofLink}}" width="180px"></img>
//         </mj-column>
//       {{/each}}
//     </mj-section>
//   `;
// };

const generateProofBlock = () => `
  <mj-wrapper padding="0" background-color="#ffffff">
    <mj-section  background-color="#fafdfd" padding="0 10px 10px 10px">
      <mj-column padding="0">
        <mj-text>
          {{#each images}}
            <div style="display: inline-block; min-width: 165px; width: 165px; height: 165px; padding: 10px;">
              <a href="{{this.viewProofLink}}">
                <div style="min-width: 145px; width: 145px; height: 145px; background-color: #f9f9fb; border: 1px dashed #e5e9ec; border-radius: 10px; padding: 0px; margin-left: 20px; margin-right: 20px;">
                  <div style="display: table-cell; vertical-align: middle; min-width: 145px; width: 145px; height: 145px;">
                    {{#if (bool this.imageUri)}}
                      <img src="{{this.imageUri}}" style="display: block; max-width: 145px; max-height: 145px; border-radius: 9px; margin: auto;" />
                    {{/if}}
                    {{#if (neg this.imageUri)}}
                      <img src="'https://memoya-production.s3.amazonaws.com/default/restore-retouch-photo-service-drop-down-menu-old-photo-restoration-200x150.jpg'" style="width: 100%; height: 100%; max-width: 145px; max-height: 145px; border-radius: 9px; margin: auto;" />
                    {{/if}}
                  </div>
                </div>
              </a>
            </div>
          {{/each}}
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-wrapper>
`;

const generateHeader = () => `
  <mj-wrapper padding="0">
    <mj-section padding="0">
      <mj-column >
        <mj-text align="center" padding="0">
          <div class="header-wrap">
            <div class="header-logo-wrap">
              <a href="https://foreverstudios.com/" target="_blank">
                <img class="header-logo-img" alt="Forever studios" src="https://memoya-production.s3.amazonaws.com/default/forever-studios-logo.png" />
              </a>
            </div>
            <div class="header-link-wrap">
              <div style="display: inline-block">
                <a class="header-link" href="{{trackPageUrl}}">TRACK ORDER </a>
              </div>
              <span class="header-divider">|</span>
              <div style="display: inline-block">
                <a class="header-link" href="{{orderDetailsUrl}}">MY ACCOUNT</a>
              </div>
              <span class="header-divider">|</span>
              <div style="display: inline-block">
                <a class="header-link" href="https://foreverstudios.com/forever-care/">FOREVER CARE</a>
              </div>
            </div>
          </div>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-wrapper>
`;

const generateCustomHeader = (data = {}) => {
  const {
    logoUrl = 'https://memoya-production.s3.amazonaws.com/default/forever-studios-logo.png',
    logoLink = 'https://foreverstudios.com/',
    showTrackOrder = true,
    showMyAccount = true,
    showCustomLink = true,
    customLinkUrl = 'https://foreverstudios.com/forever-care/',
    customLinkText = 'FOREVER CARE',
  } = data;

  const links = [];

  if (showTrackOrder) {
    links.push(`
      <div style="display: inline-block">
        <a class="header-link" href="{{trackPageUrl}}">TRACK ORDER</a>
      </div>
    `);
  }

  if (showMyAccount) {
    links.push(`
      <div style="display: inline-block">
        <a class="header-link" href="{{orderDetailsUrl}}">MY ACCOUNT</a>
      </div>
    `);
  }

  if (showCustomLink) {
    links.push(`
      <div style="display: inline-block">
        <a class="header-link" href="${customLinkUrl}">${customLinkText}</a>
      </div>
    `);
  }

  const linksHtml = links.join('<span class="header-divider">|</span>');

  return `
  <mj-wrapper padding="0">
    <mj-section padding="0">
      <mj-column>
        <mj-text align="center" padding="0">
          <div class="header-wrap">
            <div class="header-logo-wrap">
              <a href="${logoLink}" target="_blank">
                <img class="header-logo-img" alt="Logo" src="${logoUrl}" />
              </a>
            </div>
            ${linksHtml ? `<div class="header-link-wrap">${linksHtml}</div>` : ''}
          </div>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-wrapper>
`;
};

const generateConcierge = () => `
    <mj-wrapper padding="0" background-color="#ffffff">
      <mj-section padding="0">
        <mj-column padding="0 25px" width="75%">
          <mj-text align="center" padding="0">
<!--            <div class="concierge-title">-->
<!--              Need help {{firstName}}?-->
<!--            </div>-->
<!--            <div class="concierge-description">-->
<!--              I'm {{concierge.firstName}}, your Forever Concierge.-->
<!--            </div>-->
            <div class="concierge-container">
              <a href="tel:561-235-7808" style="text-decoration: none">
                <div class="concierge-wrap-for-item">
                  <img class="concierge-icon" alt="561-235-7808" src="https://memoya-production.s3.amazonaws.com/default/call-icon.png" />
                  <div class="concierge-name">561-235-7808</div>
                </div>
              </a>
              <a href="https://calendly.com/forever-studios/15min?month" style="text-decoration: none">
                <div class="concierge-wrap-for-item">
                  <img class="concierge-icon" alt="SCHEDULE MEETING" src="https://memoya-production.s3.amazonaws.com/default/zoom-icon.png" width="100%" />
                  <div class="concierge-name">ZOOM</div>
                </div>
              </a>
              <a href="https://foreverstudios.com/forever-care/" style="text-decoration: none">
                <div class="concierge-wrap-for-item">
                  <img class="concierge-icon" alt="FOREVER CARE" src="https://memoya-production.s3.amazonaws.com/default/email-icon.png" width="100%" />
                  <div class="concierge-name">FOREVER CARE</div>
                </div>
              </a>
            </div>
          </mj-text>
        </mj-column>
<!--        <mj-column padding="8px" width="25%">-->
<!--          <mj-text align="center" padding="0">-->
<!--            <a href="https://foreverstudios.com/" target="_blank">-->
<!--              <img alt="Forever studios" src="{{concierge.avatarUrl}}" width="100%"></img>-->
<!--            </a>-->
<!--          </mj-text>-->
<!--        </mj-column>-->
      </mj-section>
    </mj-wrapper>
  `;

const generatePreFooter = () => `
  <mj-wrapper padding="0" background-color="#d7e8f0">
    <mj-section padding="0">
      <mj-column padding="5px 10px">
        <mj-text align="center" padding="0">
          <div class="pre-footer-content" style="text-align: center">
            <div style="
              color: #293241;
              font-size: 26px;
              font-weight: 700;
              letter-spacing: normal;
              line-height: 1.2;
              text-align: center;
              padding-bottom: 10px;
              padding-top: 10px;
            ">
              Have Questions About Your Project?
            </div>
            <div style="padding: 5px 5px 10px 5px">
              <a href="https://foreverstudios.com/forever-care/" style="
                width: 324px;
                text-decoration: none;
                display: inline-block;
                color: #ffffff;
                background-color: #6089a3;
                border-radius: 0;
                border: none;
                font-weight: 600;
                padding-top: 9px;
                padding-bottom: 9px;
                font-size: 16px;
                text-align: center;
              ">
                VISIT OUR HELP CENTER
              </a>
            </div>
          </div>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-wrapper>
`;

const generateIconsBlock = () => `
  <mj-wrapper padding="0" background-color="#fff">
    <mj-section padding="0">
      <mj-column padding="5px 10px">
        <mj-text align="center" padding="0">
          <div class="icons-content" style="text-align: center; padding-bottom: 20px; padding-top: 10px;">
            <div class="icon-content-first" style="text-align: center; display: inline-block;">
              <a href="https://foreverstudios.com/" style="text-decoration: none; text-align: center; display: inline-block;">
                <img style="padding:10px 5px; width: 42px;" alt="icon" src="https://memoya-production.s3.amazonaws.com/default/zoom-icon.png" width="100%" />
                <div style="font-size: 11px; font-weight: 400; color: #293241; vertical-align: middle; text-align: center;">CALL US</div>
              </a>
            </div>
            <div class="icon-content" style="text-align: center; display: inline-block;">
              <a href="https://foreverstudios.com/" style="text-decoration: none; text-align: center; display: inline-block;">
                <img style="padding:10px 5px; width: 42px;" alt="icon" src="https://memoya-production.s3.amazonaws.com/default/zoom-icon.png" width="100%" />
                <div style="font-size: 11px; font-weight: 400; color: #293241; vertical-align: middle; text-align: center;">ORDER ONLINE</div>
              </a>
            </div>
            <div class="icon-content" style="text-align: center; display: inline-block;">
              <a href="https://foreverstudios.com/" style="text-decoration: none; text-align: center; display: inline-block;">
                <img style="padding:10px 5px; width: 42px;" alt="icon" src="https://memoya-production.s3.amazonaws.com/default/zoom-icon.png" width="100%" />
                <div style="font-size: 11px; font-weight: 400; color: #293241; vertical-align: middle; text-align: center;">SCHEDULE ART</div>
              </a>
            </div>
            <div class="icon-content-last" style="text-align: center; display: inline-block;">
              <a href="https://foreverstudios.com/" style="text-decoration: none; text-align: center; display: inline-block;">
                <img style="padding:10px 5px; width: 42px;" alt="icon" src="https://memoya-production.s3.amazonaws.com/default/zoom-icon.png" width="100%" />
                <div style="font-size: 11px; font-weight: 400; color: #293241; vertical-align: middle; text-align: center;">VISIT US</div>
              </a>
            </div>
          </div>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-wrapper>
`;

const generateFooter = () => `
  <mj-wrapper padding="0" background-color="#ffffff">
    <mj-section padding="0">
      <mj-column width="100%">
        <mj-text padding="0" align="center">
          <div class="footer-content-block">
            <div style="text-align: center;">
              <span class="footer-content-block-text">
                Explore Exciting Content From Our Team.
              </span>
            </div>
            <div>
              <a href="https://foreverstudios.com/blog/" class="footer-button">
                VINTAGE UNIVERSITY BLOG
              </a>
            </div>
            <div>
              <a class="social-icon-wrap" href="https://www.facebook.com/ForeverStudiosFL">
                <img class="social-icon" src="https://memoya-production.s3.amazonaws.com/default/facebook-icon.png" alt="facebook-icon"/>
              </a>
              <a class="social-icon-wrap" href="https://twitter.com/Forever_studios">
                <img class="social-icon" src="https://memoya-production.s3.amazonaws.com/default/twitter-icon.png" alt="twitter-icon"/>
              </a>
              <a class="social-icon-wrap" href="https://www.instagram.com/forever_studios/">
                <img class="social-icon" src="https://memoya-production.s3.amazonaws.com/default/instagram-icon.png" alt="instagram-icon"/>
              </a>
              <a class="social-icon-wrap" href="https://www.youtube.com/channel/UCgyUMV4HWMx-XasFPTc7cyQ">
                <img class="social-icon" src="https://memoya-production.s3.amazonaws.com/default/youtube-icon.png" alt="youtube-icon"/>
              </a>
            </div>
          </div>
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section padding="0 0 40px">
      <mj-column>
        <mj-text padding="0">
          <div class="footer-first-bottom-block" style="text-align: center;">
            <div style="display: inline-block">
              <a class="footer-page-link" href="https://foreverstudios.com/media-digitizing-service/">DIGITIZE</a>
              <span class="footer-divider">|</span>
              <a class="footer-page-link" href="https://foreverstudios.com/old-photo-restoration/">ENHANCE</a>
              <span class="footer-divider">|</span>
              <a class="footer-page-link" href="https://foreverstudios.com/create-photo-art/">PRINT</a>
            </div>
          </div>
        </mj-text>
        <mj-text padding="0">
          <div class="footer-copyright-text">
            © 2025 Legacy Media Group, LLC
          </div>
        </mj-text>
        <mj-text padding="0">
          <a class="footer-copyright-text footer-contact-link" href="tel:800-916-6076">800-916-6076</a>
        </mj-text>
        <mj-text padding="0">
          <a class="footer-copyright-text footer-contact-link" href="https://www.google.com/maps/place/1000+Clint+Moore+Rd+%23+208,+Boca+Raton,+FL+33487">1000 Clint Moore Road, Suite 208, Boca Raton, FL 33487, United States</a>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-wrapper>
`;

const generateCustomFooter = (data = {}) => {
  const {
    // Top block settings
    showTopBlock = true,
    topBlockText = 'Explore Exciting Content From Our Team.',
    showBlogButton = true,
    blogButtonText = 'VINTAGE UNIVERSITY BLOG',
    blogButtonUrl = 'https://foreverstudios.com/blog/',

    // Social links
    showSocialLinks = true,
    showFacebook = true,
    facebookUrl = 'https://www.facebook.com/ForeverStudiosFL',
    showTwitter = true,
    twitterUrl = 'https://twitter.com/Forever_studios',
    showInstagram = true,
    instagramUrl = 'https://www.instagram.com/forever_studios/',
    showYoutube = true,
    youtubeUrl = 'https://www.youtube.com/channel/UCgyUMV4HWMx-XasFPTc7cyQ',

    // Bottom navigation links
    showBottomLinks = true,
    showDigitizeLink = true,
    digitizeLinkText = 'DIGITIZE',
    digitizeLinkUrl = 'https://foreverstudios.com/media-digitizing-service/',
    showEnhanceLink = true,
    enhanceLinkText = 'ENHANCE',
    enhanceLinkUrl = 'https://foreverstudios.com/old-photo-restoration/',
    showPrintLink = true,
    printLinkText = 'PRINT',
    printLinkUrl = 'https://foreverstudios.com/create-photo-art/',

    // Copyright and contact
    copyrightText = '© 2025 Legacy Media Group, LLC',
    showPhone = true,
    phoneNumber = '800-916-6076',
    phoneUrl = 'tel:800-916-6076',
    showAddress = true,
    addressText = '1000 Clint Moore Road, Suite 208, Boca Raton, FL 33487, United States',
    addressUrl = 'https://www.google.com/maps/place/1000+Clint+Moore+Rd+%23+208,+Boca+Raton,+FL+33487',
  } = data;

  // Generate social links
  const socialLinks = [];
  if (showSocialLinks) {
    if (showFacebook) {
      socialLinks.push(`
        <a class="social-icon-wrap" href="${facebookUrl}">
          <img class="social-icon" src="https://memoya-production.s3.amazonaws.com/default/facebook-icon.png" alt="facebook-icon"/>
        </a>
      `);
    }
    if (showTwitter) {
      socialLinks.push(`
        <a class="social-icon-wrap" href="${twitterUrl}">
          <img class="social-icon" src="https://memoya-production.s3.amazonaws.com/default/twitter-icon.png" alt="twitter-icon"/>
        </a>
      `);
    }
    if (showInstagram) {
      socialLinks.push(`
        <a class="social-icon-wrap" href="${instagramUrl}">
          <img class="social-icon" src="https://memoya-production.s3.amazonaws.com/default/instagram-icon.png" alt="instagram-icon"/>
        </a>
      `);
    }
    if (showYoutube) {
      socialLinks.push(`
        <a class="social-icon-wrap" href="${youtubeUrl}">
          <img class="social-icon" src="https://memoya-production.s3.amazonaws.com/default/youtube-icon.png" alt="youtube-icon"/>
        </a>
      `);
    }
  }

  // Generate bottom navigation links
  const bottomLinks = [];
  if (showBottomLinks) {
    if (showDigitizeLink) {
      bottomLinks.push(`<a class="footer-page-link" href="${digitizeLinkUrl}">${digitizeLinkText}</a>`);
    }
    if (showEnhanceLink) {
      bottomLinks.push(`<a class="footer-page-link" href="${enhanceLinkUrl}">${enhanceLinkText}</a>`);
    }
    if (showPrintLink) {
      bottomLinks.push(`<a class="footer-page-link" href="${printLinkUrl}">${printLinkText}</a>`);
    }
  }

  const bottomLinksHtml = bottomLinks.join('<span class="footer-divider">|</span>');

  return `
  <mj-wrapper padding="0" background-color="#ffffff">
    ${showTopBlock ? `
    <mj-section padding="0">
      <mj-column width="100%">
        <mj-text padding="0" align="center">
          <div class="footer-content-block">
            <div style="text-align: center;">
              <span class="footer-content-block-text">
                ${topBlockText}
              </span>
            </div>
            ${showBlogButton ? `
            <div>
              <a href="${blogButtonUrl}" class="footer-button">
                ${blogButtonText}
              </a>
            </div>
            ` : ''}
            ${socialLinks.length > 0 ? `
            <div>
              ${socialLinks.join('\n')}
            </div>
            ` : ''}
          </div>
        </mj-text>
      </mj-column>
    </mj-section>
    ` : ''}
    <mj-section padding="0 0 40px">
      <mj-column>
        ${bottomLinksHtml ? `
        <mj-text padding="0">
          <div class="footer-first-bottom-block" style="text-align: center;">
            <div style="display: inline-block">
              ${bottomLinksHtml}
            </div>
          </div>
        </mj-text>
        ` : ''}
        <mj-text padding="0">
          <div class="footer-copyright-text">
            ${copyrightText}
          </div>
        </mj-text>
        ${showPhone ? `
        <mj-text padding="0">
          <a class="footer-copyright-text footer-contact-link" href="${phoneUrl}">${phoneNumber}</a>
        </mj-text>
        ` : ''}
        ${showAddress ? `
        <mj-text padding="0">
          <a class="footer-copyright-text footer-contact-link" href="${addressUrl}">${addressText}</a>
        </mj-text>
        ` : ''}
      </mj-column>
    </mj-section>
  </mj-wrapper>
`;
};

export {
  generateMjml,
  generateColumns,
  generateHeading,
  generateText,
  generateSpace,
  generateSeparator,
  generateImage,
  generateButton,
  generateSocialLinks,
  generateFrameBlock,
  generateHeader,
  generateCustomHeader,
  generatePreFooter,
  generateFooter,
  generateCustomFooter,
  generateConcierge,
  generateProofBlock,
  generateInvoice,
  generateIconsBlock,
};
